<template>
  <div class="all">
    <p class="title">Are you sure?</p>
    <p class="subtitle">
      Do you really want to delete this connector? This process cannot be undone.
    </p>
    <b-button
      variant="outline-danger"
      class="red"
      v-on:click="deleteConnector()"
      >Yes</b-button
    >
    <b-button variant="primary" class="blue" v-on:click="close()">No</b-button>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "DeleteConnector",
  data() {
    return {};
  },
  props: {
    connectorId: Number,
  },
  mounted() {
    this.project = this.$store.getters.getProject;
    if (!this.project) {
      this.project = this.$route.params.id;
    }
  },
  methods: {
    deleteConnector() {
      api.deleteConnector(this.project, this.connectorId).then(() => {
         this.$bvModal.hide("warning");
      });
      this.$emit('delete-connector', this.connectorId);
    },
    close() {
      this.$bvModal.hide("warning");
    },
  },
};
</script>

<style scoped>
.all {
  text-align: center;
  margin-bottom: 40px;
}
.title {
  font-weight: 500;
  font-size: 36px;
  line-height: 54px;
  text-align: center;
  color: #232c68;
}
.subtitle {
  font-size: 23px;
  line-height: 36px;
  text-align: center;
  color: #232c68;
}
.red {
  width: 170px;
  height: 40px;

  border: 2px solid #f03738;
  border-radius: 52px;
  margin-right: 40px;
  margin-top: 30px;
}
.blue {
  margin-top: 30px;
  width: 170px;
  height: 40px;

  background: #232c68;
  border: 0.5px solid #c1c1c1;
  border-radius: 52px;
}
</style>
